import React, { useState } from "react";
import Navbar from "../../../sections/Navbar";
import FrontFooter from "../../shared/FrontFooter/FrontFooter";
import "react-input-range/lib/css/index.css";
import FilterItems from "./FilterItems";
import StarRatingComponent from "react-star-rating-component";
import { useGetProductListQuery } from "../../../utils/api/product/product.api";
import Skeleton from "react-loading-skeleton";
import { useNavigate, useSearchParams } from "react-router-dom";
import Swal from "sweetalert2";
import { Color } from "../../../utils/theme";
import { Product } from "../../../utils/api/product/product.type";
import { useGetPromotionListQuery } from "../../../utils/api/promotion/promotion.api";
import { Promotion } from "../../../utils/api/promotion/promotion.type";

let options = [
  { label: "Nombre d'avis", value: "avreageRate" },
  { label: "Date de création", value: "createdAt" },
  { label: "Nom", value: "name" },
  { label: "Note moyenne", value: "rateCount" },
  { label: "Prix", value: "price" },
];

const ParcoursAchat = () => {
  const { data: promotions = [] } = useGetPromotionListQuery({});
  let [searchParams, setSearchParams] = useSearchParams();
  const [searchCategory, setSearchCategory] = useState<any>();
  const [searchSousCategory, setSearchSousCategory] = useState<any>();
  const [searchPrix, setSearchPrix] = useState<any>([]);
  const [show, setShow] = useState(false);

  const [query, setQuery] = React.useState({
    category: searchParams?.get("category") || "",
    min: searchParams?.get("min") || "",
    max: searchParams?.get("max") || "",
    orderBy: searchParams?.get("orderBy") || "",
  });
  const [value, setValue] = React.useState<any>({
    min: searchParams?.get("min") || 1000,
    max: searchParams?.get("max") || 10000,
  });
  const [page, setPage] = React.useState(1);
  const { data = { results: [], nbPage: 0 }, isLoading } =
    useGetProductListQuery({
      productType: "product",
      page,
      minPrice: searchParams?.get("min") || "",
      maxPrice: searchParams?.get("max") || "",
      orderBy: searchParams?.get("orderBy") || "",
      order: "ASC",
      category: searchParams?.get("category")
        ? JSON.parse(searchParams?.get("category") || "[]")
        : "",
    });
  const [lastPromo, setLastPromo] = React.useState<Promotion | undefined>();

  React.useEffect(() => {
    if (promotions?.length) {
      setLastPromo(promotions[promotions?.length - 1]);
    }
  }, [promotions]);

  const handleSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    let queryCopy = { ...query };
    queryCopy = { ...queryCopy, orderBy: e?.target?.value };
    setQuery(queryCopy);
  };

  return (
    <div className="landing-page-component">
      <Navbar />
      <div className="page-content">
        <div className="container-easy-market">
          <div className="row row-achat-page mb-5">
            <FilterItems
              searchParams={searchParams}
              setSearchParams={setSearchParams}
              query={query}
              setQuery={setQuery}
              setPage={setPage}
            />
            <div className="col-lg-9 col-md-7 col-right-achat-page">
              <div className="content-col-right-achat-page">
                {!!promotions?.length && <div></div>}
                <div
                  className="container-home-page mb-3 no-view-mobile"
                  style={{ minHeight: "51rem" }}
                >
                  <div className="content-btn-title-home-page flex-r py-3">
                    <div className="tab-dash-admin-filter-container">
                      <form className="row g-3 tab-dash-admin-filter-form">
                        <div className="col-auto">
                          <label
                            htmlFor="filtreProduit"
                            className="tab-dash-admin-filter-label"
                            style={{ fontWeight: 700, color: "#000" }}
                          >
                            Trier par
                          </label>
                        </div>
                        <div className="col-auto">
                          <select
                            className="form-control filter-select-product"
                            value={searchParams?.get("orderBy") || ""}
                            onChange={(e) => handleSelect(e)}
                          >
                            <option value="">Pertinence</option>
                            {options?.map((opt, i) => (
                              <option value={opt?.value} key={i}>
                                {opt?.label}
                              </option>
                            ))}
                          </select>
                        </div>
                      </form>
                    </div>
                  </div>
                  <div className="row mt-3"></div>
                  <div className="d-flex justify-content-center"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FrontFooter />
    </div>
  );
};

export default ParcoursAchat;

export const ProductItemsSkeleton = () => {
  return (
    <>
      {Array(12)
        .fill(12)
        .map((item, i) => (
          <div
            className="col-md-6 col-lg-4 col-xl-3 mb-3 col-product-item d-flex"
            key={i}
          >
            <div
              className="product-item-container"
              style={{ textAlign: "center" }}
            >
              <div className="content-img-product-item">
                <Skeleton className="img-product-item" />
              </div>
              <div className="content-btn-buy-product-item py-3">
                <Skeleton
                  className="btn btn-buy-product-item bg-transparent"
                  width={`50%`}
                />
              </div>
              <div className="text-center">
                <Skeleton className="price-product-item" width={`60%`} height={20} />
                <Skeleton className="name-prduct fs-15" height={15} width={`70%`} />
                <div className="content-rate-product">
                  <StarRatingComponent
                    name="rate2"
                    starCount={5}
                    value={0}
                    starColor="#000000"
                    emptyStarColor="#D4D6D5"
                  />
                </div>
              </div>
            </div>
          </div>
        ))}
    </>
  );
};

export function AddedCartConform(item: Product) {
  const navigate = useNavigate();
  const onConfirm = async () => {
    await Swal.fire({
      icon: "success",
      html: `<div class="sweet-container"> ${item?.nom} <strong>a été ajouté au panier</strong> </div>`,
      showCancelButton: true,
      confirmButtonText: "CONFIRMER",
      cancelButtonText: "POURSUIVRE MES ACHATS",
      showLoaderOnConfirm: true,
      iconColor: Color.default,
      confirmButtonColor: Color.default,
      customClass: {
        confirmButton: "btn btn-sweet-confirm",
        cancelButton: "btn btn-sweet-cancel",
      },
      reverseButtons: true,
    }).then((result: any) => {
      if (result?.isConfirmed) {
        navigate("/valider-commande");
      }
    });
  };
  return onConfirm;
}